import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { Spacer } from 'components/Utility'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'

type Props = {
  alert?: string
  description?: string
  headline: string
  title: string
}

const AlertCard: FC<Props> = React.memo((props) => {
  const { alert, description, headline, title } = props

  return (
    <div className={styles.caution}>
      <div className={styles.caution__title}>
        <img src={'/icon/red/caution.svg'} alt={'注意'} />
        <Spacer size={5} axis={'horizontal'} />
        {title}
      </div>
      <Spacer size={8} />
      <p className={styles.caution__headline}>{HTMLReactParser(returnCodeToBr(headline))}</p>
      {description && (
        <>
          <Spacer size={8} />
          <p className={styles.caution__description}>{HTMLReactParser(returnCodeToBr(description))}</p>
        </>
      )}
      {alert && (
        <>
          <Spacer size={8} />
          <p className={styles.caution__alert}>{HTMLReactParser(returnCodeToBr(alert))}</p>
        </>
      )}
    </div>
  )
})

export default AlertCard
